export const MeetingStatus = {
  Loading: 0,
  Succeeded: 1,
  Failed: 2,
  Ended: 3
}
